/**
 * Meniul lateral DXD.
 *
 * Deschis din orice element cu [data-dxd-drawer-open], închis din buton, din
 * fundal sau cu Esc. Folosește <dialog>.showModal(), deci capcana de focus,
 * Esc și inertizarea restului paginii vin de la browser.
 */
const DRAWER_ID = 'dxd-menu-drawer';

function getDrawer() {
  return document.getElementById(DRAWER_ID);
}

function open() {
  const drawer = getDrawer();
  if (!drawer || drawer.open) return;

  drawer.showModal();
  // Clasa declanșează tranziția de intrare după ce dialogul e deja afișat.
  requestAnimationFrame(() => drawer.classList.add('is-open'));
}

function close() {
  const drawer = getDrawer();
  if (!drawer || !drawer.open) return;

  drawer.classList.remove('is-open');

  const panel = drawer.querySelector('.dxd-drawer__panel');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!panel || reduced) {
    drawer.close();
    return;
  }

  // Așteptăm sfârșitul tranziției ca panoul să iasă din ecran înainte de close().
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    drawer.close();
  };

  panel.addEventListener('transitionend', finish, { once: true });
  window.setTimeout(finish, 400);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-dxd-drawer-open]');
  if (trigger) {
    event.preventDefault();
    open();
    return;
  }

  if (event.target.closest('[data-dxd-drawer-close]')) {
    event.preventDefault();
    close();
    return;
  }

  // Căutarea din meniu: închide meniul și deschide aceeași căutare a temei
  // pe care o folosește bara din header.
  if (event.target.closest('[data-dxd-drawer-search]')) {
    event.preventDefault();
    close();

    const trigger = document.querySelector(
      '.header__row--top search-button button, search-button button'
    );
    if (trigger) window.setTimeout(() => trigger.click(), 280);
    return;
  }

  // Click pe fundal: <dialog> primește click-ul doar când e în afara panoului.
  const drawer = getDrawer();
  if (drawer && event.target === drawer) close();
});

// Esc declanșează evenimentul nativ „cancel"; îl preluăm ca să animăm ieșirea.
document.addEventListener('cancel', (event) => {
  if (event.target && event.target.id === DRAWER_ID) {
    event.preventDefault();
    close();
  }
});
